import React, { useEffect, useState } from 'react';
import {
  getArtisanJobsPendingAction,
  deleteJobAction
} from '../../../../modules/artisanJobs/Actions';
import {
  artisanJobsPendingSelector,
  artisanJobsIsLoadingSelector,
  artisanJobsCountSelector,
  searchValueSelector
} from '../../../../modules/artisanJobs/Selectors';
import { connect } from 'react-redux';
import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import getLangData from '../../../../utils/getLangData';
import { Link } from 'react-router-dom';
import CJobItem from '../../../../components/UI/Card/CJobItem';
import CJobDetail from '../../../../components/UI/Card/CJobDetail';
import CJobItemApplicant from '../../../../components/UI/Card/CJobItemApplicant';

const ArtisanJobsListPending = props => {
  const {
    artisanJobs,
    isLoading,
    getArtisanJobs,
    artisanJobsCount,
    searchValue,
    currentUser,
    deleteJobAction
  } = props;
  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [activeJob, setActiveJob] = useState({});

  const artisanId = currentUser?.profiles?.artisan?._id;
  useEffect(() => {
    if (artisanId)
      getArtisanJobs({ size, offset, searchTerm: searchValue, artisanId });
  }, [getArtisanJobs, searchValue, artisanId]);

  useEffect(() => {
    if (Object.keys(activeJob).length === 0 && artisanJobs.length > 0)
      setActiveJob(artisanJobs[0]);
  }, [artisanJobs]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (artisanJobs.length >= artisanJobsCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getArtisanJobs({
      size,
      offset: artisanJobs.length,
      searchTerm: searchValue,
      artisanId
    });
  };

  //
  const dataLength =
    artisanJobs.length <= artisanJobsCount
      ? artisanJobs.length
      : artisanJobsCount;

  return (
    <>
      <div className='body w-100'>
        {/* Content */}
        <div className='container'>
          <div className='row block--container my-5'>
            {/* Header */}

            <div className='header col-12 pb-3'>
              <div className='d-flex justify-content-between align-items-center'>
                <h2 className='my-auto'>وظائف تحت المراجعة</h2>
                <div
                  className='job--details my-auto, mr-4'
                  style={{ height: 'auto', minHeight: 'auto' }}
                >
                  <div className='actions'>
                    <Link
                      type='button'
                      className='btn edit'
                      title='Add new job'
                      to={`/jobs/artisan/create`}
                      data-original-title='Add New Job'
                    >
                      <i class='fas fa-plus-square'></i>{' '}
                    </Link>
                    <Link
                      type='button'
                      className='btn trash'
                      title='Live Jobs'
                      data-original-title='Pending'
                      aria-describedby='tooltip694840'
                      to={`/jobs/artisan/`}
                    >
                      <i class='fas fa-toggle-on'></i>{' '}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* Content */}
            <div className='col-12 row'>
              {/* Jobs List */}
              <div className='col-6'>
                <InfiniteScroll
                  dataLength={dataLength}
                  hasMore={hasMore}
                  next={fetchMore}
                  style={{ overflow: 'hidden' }}
                >
                  <div className='jobs--container custom--scrollbar'>
                   <CJobItemApplicant />
                    {artisanJobs.map((jobData, index) => {
                      console.log(jobData._id, 'jobjob');
                      return (
                        <a
                          key={jobData._id}
                          onClick={() => {
                            setActiveJob(jobData);
                          }}
                        >
                          <CJobItem
                            data={jobData}
                            active={jobData._id === activeJob._id}
                          />
                        </a>
                      );
                    })}
                  </div>
                </InfiniteScroll>
                <CJobItem />
              </div>
              {/* Job Details */}
              <div className='col-6'>
                {Object.keys(activeJob).length > 0 && (
                  <CJobDetail data={activeJob} deleteAction={deleteJobAction} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  artisanJobs: artisanJobsPendingSelector(state),
  isLoading: artisanJobsIsLoadingSelector(state),
  artisanJobsCount: artisanJobsCountSelector(state),
  searchValue: searchValueSelector(state),
  currentUser: state?.users?.currentUser
});

export default connect(mapStateToProps, {
  getArtisanJobs: getArtisanJobsPendingAction,
  deleteJobAction
})(ArtisanJobsListPending);
